import React from 'react';
import { FormField } from './FormField';
import { SchemaField, FormData, FormErrors } from './types';

interface DetailSectionProps {
  fields: SchemaField[];
  formData: FormData;
  errors: FormErrors;
  getDisplayValue: (field: SchemaField) => string;
  getInputClass: (fieldName: string, baseClass?: string) => string;
  handleChange: (name: string, value: string | boolean) => void;
  handleArrayChange: (name: string, idx: number, value: string) => void;
  addArrayItem: (name: string) => void;
  removeArrayItem: (name: string, idx: number) => void;
}

export function DetailSection({
  fields,
  formData,
  errors,
  getDisplayValue,
  getInputClass,
  handleChange,
  handleArrayChange,
  addArrayItem,
  removeArrayItem,
}: DetailSectionProps) {
  if (fields.length === 0) return null;

  return (
    <div className="space-y-4">
      <div className="space-y-4">
        {fields
          .filter(field => field.type !== 'hidden')
          .map(field => (
            <FormField
              key={field.name}
              field={field}
              formData={formData}
              errors={errors}
              textareaMinHeight="min-h-[120px]"
              getDisplayValue={getDisplayValue}
              getInputClass={getInputClass}
              handleChange={handleChange}
              handleArrayChange={handleArrayChange}
              addArrayItem={addArrayItem}
              removeArrayItem={removeArrayItem}
            />
          ))}
      </div>
    </div>
  );
}
